import { render, staticRenderFns } from "./TravelRequestDetail.vue?vue&type=template&id=c6e1671a&"
import script from "./TravelRequestDetail.vue?vue&type=script&lang=js&"
export * from "./TravelRequestDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports